import React, {useState} from 'react';
import {ActivityIndicator, Platform, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react';

import PaymentMethod from '../../components/payments/till/PaymentMethod';
import Button from '../../components/ui-controls/Button';
import {ErrorDialog} from '../../components/ui-controls/ErrorDialog';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {AppRoute} from '../../models/AppRoute';
import ThreeDsMobileBrowserDataIframe from '../../screens/cart/components/ThreeDsMobileBrowserDataIframe';
import useFetchMobileWebView3dsBrowserDataJSFocusEffect from '../../screens/cart/useFetchMobileWebView3dsBrowserDataJSFocusEffect';
import {useStores} from '../../stores/use-stores';
import {getApiErrorMessage} from '../../utils/mfl';
import {MAX_FORM_WIDTH} from '../constants';
import {GiftCardShopRouteNavigatorScreenProps} from '../types/navigationTypes';

import OrderTotals from './OrderTotals';

export const GiftCardStoreCheckoutScreen = observer(
  ({
    navigation,
  }: GiftCardShopRouteNavigatorScreenProps<AppRoute.GIFT_CARDS_STORE_CHECKOUT>) => {
    const {cartStore} = useStores();

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState('');

    const {mobileWebView3DsBrowserDataJS, browserData, setBrowserData} =
      useFetchMobileWebView3dsBrowserDataJSFocusEffect();

    const handleFormSubmit = async () => {
      setIsSubmitting(true);
      try {
        await cartStore.checkoutOrder(navigation, browserData);
      } catch (error: any) {
        console.error(error);
        const errorMessage = getApiErrorMessage(error);
        setSubmitErrorMessage(errorMessage);
      } finally {
        setIsSubmitting(false);
      }
    };
    const handleBack = () =>
      navigation.navigate(AppRoute.GIFT_CARDS_STORE_REVIEW);

    const handleErrorDialogOk = () => setSubmitErrorMessage('');

    if (Platform.OS !== 'web' && !mobileWebView3DsBrowserDataJS) {
      return (
        <ContentView>
          <ActivityIndicator />
        </ContentView>
      );
    }

    return (
      <ContentView style={styles.formView}>
        <PaymentMethod
          navigationTarget={AppRoute.GIFT_CARDS_STORE_CHECKOUT}
          showTitle={false}
        />
        <View style={styles.button} />
        <OrderTotals />
        <Button
          onPress={handleFormSubmit}
          title="CONFIRM PAYMENT"
          loading={isSubmitting}
          disabled={isSubmitting}
          style={styles.button}
        />
        <Button
          disabled={isSubmitting}
          onPress={handleBack}
          style={styles.button}
          title="BACK"
          type="outline"
        />
        <ErrorDialog
          isVisible={!!submitErrorMessage}
          onOk={handleErrorDialogOk}
        />
        <ThreeDsMobileBrowserDataIframe
          mobileWebView3DsBrowserDataJS={mobileWebView3DsBrowserDataJS}
          onBrowserData={setBrowserData}
        />
      </ContentView>
    );
  },
);

const styles = StyleSheet.create({
  button: {
    marginTop: 16,
  },
  formView: {
    justifyContent: 'center',
    paddingHorizontal: 8,
    maxWidth: MAX_FORM_WIDTH,
  },
});

export default GiftCardStoreCheckoutScreen;
